import type { OnboardingStep } from '@kindred/types';

/**
 * Onboarding step metadata (BRD Module 2). Single source of truth for the
 * 5-step order + labels shared by the StepRail and the StepScreen switch.
 * Order mirrors the backend `STEP_ORDER`.
 */
export interface StepMeta {
  step: OnboardingStep;
  /** 1-based number shown in the StepBadge. */
  number: number;
  label: string;
  meta: string;
}

export const STEPS: readonly StepMeta[] = [
  { step: 'verifyMerchant', number: 1, label: 'Add your store', meta: 'Declare your domains & business name' },
  { step: 'connectFeed', number: 2, label: 'Connect product feed', meta: 'Shopify, feed URL or CSV' },
  { step: 'publishOffers', number: 3, label: 'Publish offers', meta: 'Create your first offer' },
  { step: 'confirmSiteMap', number: 4, label: 'Confirm site map', meta: 'Review & approve selectors' },
  { step: 'connectTracking', number: 5, label: 'Connect tracking', meta: 'Install the pixel & validate' },
] as const;

export const STEP_ORDER: readonly OnboardingStep[] = STEPS.map((s) => s.step);

export function stepIndex(step: OnboardingStep): number {
  return STEP_ORDER.indexOf(step);
}
